import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getFDAData } from "../../../../state/selectors/FDA.selectors";

const GeneFDACard = ({ card, fdaData }) => {
  const isDisabled = !Object.keys(fdaData || {}).length;

  const drugs = fdaData?.items
    ?.map((x) => x.drug.toLowerCase())
    .reduce((a, i) => a.add(i), new Set());

  return (
    <CardWrapper {...card} card={card} isDisabled={isDisabled}>
      {drugs && drugs.size !== 0 && (
        <div>
          {"Drugs: "}
          <span className="tw-font-bold" data-testid="fda-drugs">
            {drugs.size}
          </span>
        </div>
      )}
    </CardWrapper>
  );
};

GeneFDACard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  fdaData: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

GeneFDACard.defaultProps = {
  fdaData: {},
};

const mapStateToProps = (state) => ({
  fdaData: getFDAData(state),
});

export default connect(mapStateToProps)(GeneFDACard);
